import { MetricType } from './metric-chart.types';
import {
  tickNumberFormatter,
  tickMoneyFormatter,
  tickDurationHourFormatter,
} from './metric-chart.utils';

export const NO_DATA_LABEL = 'No data available';

export const DEFAULT_BAR_WIDTH = 12;

export const DEFAULT_BAR_COLOR = '#5DA3FF';

export const DEFAULT_LINE_COLOR = '#5DA3FF';

export const DEFAULT_CHART_HEIGHT = 180;

export const DEFAULT_TICKS_COUNT = 5;

export const MAX_COMFORTABLE_TICKS_COUNT = 14;

export const HOUR_MS = 1000 * 60 * 60;

export const DAY_MS = HOUR_MS * 24;

export const LEGEND_HEIGHT_OFFSET = 20;

export const tickFormatterMap: Record<MetricType, (value: number) => string> = {
  number: (value: number) => tickNumberFormatter(value),
  currency: (value: number) => tickMoneyFormatter(value),
  time: (value: number) => tickDurationHourFormatter(value), // interpret numeric value as minutes duration and display hours
};
